// Load Meta's JS SDK once and FB.init() it for our platform app. Embedded
// Signup runs as an FB.login() popup, so the SDK has to be present before
// the click — callers preload it when their card renders so the login
// call stays synchronous inside the click handler (popup blockers).
// Shared by WhatsApp Embedded Signup and the Meta Conversions API connect.
let fbSdkPromise = null;
export function loadFacebookSdk(appId, version) {
  if (window.FB) return Promise.resolve(window.FB);
  if (fbSdkPromise) return fbSdkPromise;
  fbSdkPromise = new Promise((resolve, reject) => {
    window.fbAsyncInit = () => {
      window.FB.init({ appId, autoLogAppEvents: false, xfbml: false, version });
      resolve(window.FB);
    };
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.onerror = () => {
      fbSdkPromise = null;
      reject(new Error('Could not load the Facebook SDK — disable ad blockers for this page and try again'));
    };
    document.body.appendChild(script);
  });
  return fbSdkPromise;
}
